import "../Main.scss";
import "./Stepper.scss";
import "../../lib/form/form.scss";
import Sub from "../Sub";
import {
  Link,
  Routes,
  Route,
  useParams,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { useState } from "react";
import StepperMui from "./StepperMui";
import { useEffect } from "react";
import axios from "axios";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Steppers from "@mui/material/Stepper";
import ConfirmModal from "../../components/ConfirmModal";
function Stepper() {
  const { state } = useLocation();
  const [stepData, setStepData] = useState([]);
  const [steps, setSteps] = useState([]);
  const [correctiveData, setCorrectiveData] = useState([]);
  const [downloadData, setDownloadData] = useState([]);
  let navigate = useNavigate();
  let { id } = useParams();
  const [activeStep, setActiveStep] = useState(0);
  const [completed, setCompleted] = useState({});
  const [firstTasks, setFirstTasks] = useState([]);
  const [firstStep, setFirstStep] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);
  const closeModal = () => {
    setShowModal(false);
  };
  const closeModal2 = () => {
    setShowModal2(false);
  };
  const handleStep = (step) => () => {
    if (step <= firstStep) {
      navigate("/stepper", { state });
      setActiveStep(step);
      getStepData(firstTasks[step], step);
    } else {
      setShowModal(true);
    }
  };
  const getStepData = async (stepId, step) => {
    // let params = state
    let params = null;
    if (stepId === undefined) {
      params = state;
    } else {
      params = state;
      params.taskGroupId = stepId.groupId;
      params.taskId = stepId.id;
      params.taskName = stepId.name;
    }
    try {
      const response = await axios.get(`/api/task-group/${params.taskGroupId}`);
      if (firstTasks.length === 0) {
        setFirstTasks(response.data.tasks);
      }
      let tempArr = [];
      for (let i = 0; i < response.data.tasks.length; i++) {
        if (params.taskName === response.data.tasks[i].name) {
          setActiveStep(i);
          if (steps.length === 0) {
            setFirstStep(i);
          }
        }
        tempArr.push(response.data.tasks[i].name);
      }
      setSteps(tempArr);

      const response2 = await axios.get("/api/apply-proc-board", {
        params: { applyProcessId: params.id, taskId: params.taskId },
      });
      // 이의불만제기 , 첫번째 동의 후 완료를 진행한경우
      if (
        state.taskGroup.type === 9 &&
        step === 2 &&
        response2.data.data.length === 0
      ) {
        setActiveStep(firstStep);
        getStepData(firstTasks[firstStep], firstStep);
        return setShowModal2(true);
      }
      // if (response2.data.data.length > 0 && state.)
      setCorrectiveData(response2.data.data);
      const response3 = await axios.get("/api/task-apply-form-attrs2", {
        params: { targetId: params.taskId, confVersion: params.confVersion },
      });
      const response4 = await axios.get("/api/task-apply-form-attrs2", {
        params: {
          targetId: response3?.data[0]?.targetId,
          applyProcId: params.id,
          confVersion: params.confVersion,
        },
      });
      // for (let i = 0; i < response4.data?.length; i++) {
      //   for (let j = 0; j < response3.data?.length; j++) {
      //     if (response4.data[i].name === response3.data[j].name) {
      //       response3.data[j].exist = 1;
      //     }
      //   }
      // }
      for (let i = 0; i < response4.data?.length; i++) {
        if (response4.data[i].fileName !== "") {
          for (let j = 0; j < response3.data?.length; j++) {
            if (response4.data[i].id === response3.data[j].id) {
              response3.data[j].exist = 1;
              break;
            }
          }
          // response3.data[i].exist = 1;
        }
      }
      setDownloadData(response3.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getStepData();
  }, []);

  return (
    <>
      {showModal ? (
        <ConfirmModal
          closeModal={closeModal}
          modalTitle={"진행단계"}
          content={`현재 진행단계(${steps[firstStep]})에서만 작업 가능합니다.`}
        />
      ) : null}
      {showModal2 ? (
        <div className="popup_bg_bbs " onClick={closeModal2}>
          <div
            className="password_change "
            style={{ width: "550px" }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="pophead_bbs">
              <h1>안내</h1>
            </div>
            <div className="password_change_inner">
              "② 조치결과 안내" 절차에서 조치결과에 대해 '동의' 처리하신 경우,
              <br />
              "③ 위원회 결정" 절차는 수행되지 않음을 안내드립니다.
              <div className="btns_wrap">
                <button className="btn_confirm" onClick={closeModal2}>
                  <span className="material-icons">확인</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      <Sub to={"/breakdown/cits"} title="나의 신청내역" />
      <div style={{ backgroundColor: "white", marginTop: "1vh" }}>
        <h3 style={{ marginLeft: "1vw" }}>
          <br />
          접수번호: {state.acceptNum}{" "}
          {state.tranQualificationNum !== null ? (
            <span style={{ marginLeft: "1vw" }}>
              인증서번호: {state.tranQualificationNum}
            </span>
          ) : null}
        </h3>
        <Steppers
          style={{ padding: "30px 30px 0px 30px" }}
          nonLinear
          activeStep={activeStep}
        >
          {steps?.map((label, index) => (
            <Step key={label} completed={completed[index]}>
              <StepButton
                // disableElevation
                disableRipple
                color="inherit"
                onClick={handleStep(index)}
              >
                {label}
              </StepButton>
            </Step>
          ))}
        </Steppers>
      </div>
      <div className="">
        <div className=" ">
          <form className="my_page bbs_contain" action="" method="">
            <div className="StepperMui_wrap">
              <StepperMui
                stepData={stepData}
                steps={steps}
                firstStep={firstStep}
                activeStep={activeStep}
                correctiveData={correctiveData}
                downloadData={downloadData}
                state={state}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Stepper;
